import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import Flex from '@wix/da-ds/pkg/Flex';
import FlexItem from '@wix/da-ds/pkg/Flex/Item';
import ExclusiveButton from '@wix/da-ds/pkg/Buttons/ExclusiveButton';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import GiftAnimated from '@wix/da-ds/pkg/Icons/GiftAnimated';
import { useEndSaleAction, useViewOffersAction, useSellerGiveAsGift } from '../../hooks';
const SellerButtons = ({ deviation, adoptableState: { canSellerViewOffers, isFreeGiftable } })=>{
    const { t } = useTranslation();
    const isGiftingEnabled = useFlag('gifting_for_sellers');
    const sectionname = 'side-rail';
    const [onViewOffers, viewOffersBiData] = useViewOffersAction(deviation, {
        sectionname
    });
    const [onGiveAsGift, giftingBiData] = useSellerGiveAsGift(deviation, {
        sectionname
    });
    const [onEndSale, endSaleBiData] = useEndSaleAction(deviation, {
        sectionname
    });
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ExclusiveButton, {
        key: "end-sale",
        priority: "secondary",
        onClick: onEndSale,
        biData: endSaleBiData
    }, t('sidebar.exclusives.buttons.seller.endSale')), isGiftingEnabled && /*#__PURE__*/ React.createElement(Flex, {
        gap: 16,
        fullWidth: true
    }, canSellerViewOffers && /*#__PURE__*/ React.createElement(FlexItem, {
        grow: true
    }, /*#__PURE__*/ React.createElement(ExclusiveButton, {
        key: "view-offers",
        priority: "primary",
        onClick: onViewOffers,
        biData: viewOffersBiData,
        variant: "compact"
    }, t('sidebar.exclusives.buttons.seller.viewOffers'))), isFreeGiftable && /*#__PURE__*/ React.createElement(FlexItem, {
        grow: true
    }, /*#__PURE__*/ React.createElement(ExclusiveButton, {
        key: "give-as-gift",
        priority: "primary",
        onClick: onGiveAsGift,
        biData: giftingBiData,
        variant: "compact"
    }, /*#__PURE__*/ React.createElement(GiftAnimated, {
        size: IconSize.MEDIUM,
        disableDefaultColors: true
    }), t('sidebar.exclusives.buttons.seller.gift.label')))), !isGiftingEnabled && canSellerViewOffers && /*#__PURE__*/ React.createElement(ExclusiveButton, {
        key: "view-offers",
        priority: "primary",
        onClick: onViewOffers,
        biData: viewOffersBiData
    }, t('sidebar.exclusives.buttons.seller.viewOffers')));
};
SellerButtons.displayName = 'SellerButtons';
export default SellerButtons;

//# sourceMappingURL=SellerButtons.js.map